import Language_v2 from '../Objects/language_v2'
import { ReportImage } from '../Objects/newReportObjects/reportImage'
import { ClientV2 } from '../Objects/newReportObjects/client_v2'
import { ReportV2 } from '../Objects/newReportObjects/report_v2'
import { PreambleImage } from '../Objects/newReportObjects/preambleImage'
import { ReportRecommendation } from '../Objects/newReportObjects/reportRecommendation'
import { ReportNarrative } from '../Objects/newReportObjects/reportNarrative'
import { Property } from '../Objects/newReportObjects/property'
import { USR } from './typeDirs'
const typeMap = {}
const User = {getTypeDir:()=>USR}
let arr = [
  Language_v2,
  ReportImage,
  ReportV2,
  ClientV2,
  PreambleImage,
  ReportRecommendation,
  ReportNarrative,
  Property,
  User
]

arr.forEach((o) => {
  // console.log(o)
  if (o && o.getTypeDir) {
    typeMap[o.getTypeDir()] = o
  }
})

if (typeof window !== 'undefined') window._ms_typeMap = typeMap

// console.log('init typeMap', typeMap)
export default typeMap
